import React from "react";
import BowlerPrizeSummary from "./BowlerPrizeSummary";
import PrizeBreakdownTable from "./PrizeBreakdownTable";
import { Pagination } from "../UI";

const BowlerSummaryView = ({
  viewMode,
  loading,
  currentPageData,
  filteredBreakdown,
  currentPage,
  totalPages,
  totalItems,
  itemsPerPage,
  onPageChange,
  onItemsPerPageChange,
  tournamentId,
}) => {
  if (loading) {
    return viewMode === "cards" ? (
      // Show skeleton cards while loading
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {Array.from({ length: 6 }).map((_, index) => (
          <BowlerPrizeSummary
            key={`skeleton-${index}`}
            bowler={{}}
            tournamentId={tournamentId}
            loading={true}
          />
        ))}
      </div>
    ) : (
      <PrizeBreakdownTable
        breakdown={[]}
        tournamentId={tournamentId}
        loading={true}
      />
    );
  }

  if (!filteredBreakdown || filteredBreakdown.length === 0) {
    return (
      <div className="card-board text-center py-12">
        <h3 className="heading-display text-lg mb-2">No prizes found</h3>
        <p className="text-brand-muted">
          Try a different search or event filter.
        </p>
      </div>
    );
  }

  return (
    <>
      {/* Prize Breakdown Content */}
      {viewMode === "cards" ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {currentPageData.map((bowler) => (
            <BowlerPrizeSummary
              key={bowler.bowlerId}
              bowler={bowler}
              tournamentId={tournamentId}
              loading={false}
            />
          ))}
        </div>
      ) : (
        <PrizeBreakdownTable
          breakdown={currentPageData}
          tournamentId={tournamentId}
          loading={false}
        />
      )}

      {/* Pagination */}
      {filteredBreakdown.length > 0 && (
        <div className="mt-6">
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            onPageChange={onPageChange}
            onItemsPerPageChange={onItemsPerPageChange}
          />
        </div>
      )}
    </>
  );
};

export default BowlerSummaryView;
